module.exports = __webpack_public_path__ + "img/share.f808f5e1.png";